import React from 'react';

/**
 * 玩偶 PNG + WebP（优先 WebP，体积更小）
 */
export default function PoloImage({
  src,
  alt,
  className,
  style,
  draggable = false,
  loading,
}) {
  const webp = src.replace(/\.png$/i, '.webp');

  return (
    <picture style={{ display: 'contents' }}>
      <source srcSet={webp} type="image/webp" />
      <img
        className={className}
        style={style}
        src={src}
        alt={alt}
        draggable={draggable}
        loading={loading}
        decoding="async"
      />
    </picture>
  );
}
